/* eslint-disable react/destructuring-assignment */
import styled from 'styled-components';
import theme from 'styled-theming';
import Button from 'components/mediabay-ui/components/Button';
import Heading from 'components/mediabay-ui/components/Heading';

export const StyledFilter = styled.div`
  position: static;
  top: 69px;
  right: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #465867 0%, #272727 100%);

  @media (min-width: 1024px) {
    position: sticky;
    top: 70px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 10px 20px;
`;

export const Container = styled.form`
  display: ${props => (props.isContainerVisible ? 'flex' : 'none')};
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px;

  @media (min-width: 1024px) {
    flex-wrap: nowrap;
  }
`;

export const LeftContainer = styled.div`
  flex: 1.5 100%;
`;

export const RightContainer = styled.div`
  flex: .5 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 500px) {
    flex-flow: wrap row;
  }
`;

export const StyledButton = styled(Button)`
  font-size: 18px;
  border: 0;
  color: ${theme('mode', { light: '#000', dark: '#fff' })};
  border: 1px solid transparent;

  &:hover {
    background: transparent;
    color: ${theme('mode', { light: '#000', dark: '#fff' })};
    border: 1px solid ${theme('mode', { light: '#000', dark: '#fff' })};
  }
`;

export const FilterHeading = styled(Heading)`
  color: ${theme('mode', { light: '#000', dark: '#fff' })};
  margin: 15px 0;
  padding: 0 10px;
`;

export const GenresColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 500px) {
    flex-flow: wrap row;
  }

  @media (min-width: 1024px) {
    flex-flow: wrap column;
    max-height: 350px;
  }
`;

export const FilterColumn = styled.div`
  display: flex;
  flex-direction: column;
  // border-left: 1px solid #979797;
  max-height: 300px;
  margin: 0 5px;
  overflow: auto;

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
      background: rgba(56, 66, 74, .7);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #272727;
  }

  &::-webkit-scrollbar-thumb:hover {
      background: #565a5a;
  }
`;

export const CheckboxTitle = styled.span`
  display: inline-block;
  color: ${theme('mode', { light: '#fff', dark: '#fff' })};
  border-radius: 24px;
  cursor: pointer;
  font-size: 18px;
  margin: 2px 0;
  padding: 7px 15px;
  transition: all 0.25s;

  &::-moz-focus-inner {
    border: 0;
  }
`;

export const StyledCheckbox = styled.input`
  display: none;
  &:checked + span {
    background: #1769ff;
  }
`;
